// extracted by mini-css-extract-plugin
module.exports = {"container":"RelatedLearningResources-module_container_2WnI_","loadingHolder":"RelatedLearningResources-module_loadingHolder_tekNX"};